import { Button, Modal, ModalVariant } from '@patternfly/react-core'
import * as React from 'react'
import { useCallback } from 'react'
import styled from 'styled-components'

import { IntakeDemographics } from '@app/components/intake/demographics'
import { IPatient } from '@app/domain/patient/patient.interface'

const FormScreen = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-content: center;
  width: 100%;
`

export interface Props {
  isOpen?: boolean
  onClose?: () => void
  setResumeStartPoint: (resumeFromStart: boolean) => void
  patient?: IPatient
  handleContinue?: () => void
  handleGoBack?: () => void
  handleSubmit?: (
    instrumentId: string,
    responses: Record<string, string>,
    preventNextScreen?: boolean,
  ) => void
}

export const IntakeResumeModal = ({ 
  setResumeStartPoint, 
  patient, 
  handleContinue: onContinue, 
  handleGoBack, 
  handleSubmit 
}: Props) => {
  const [isModalOpen, setIsModalOpen] = React.useState(true)
  const [showDemographicConfirmation, setShowDemographicConfirmation] = React.useState(false)

  const handleRestartFromBeginning = useCallback(() => {
    setResumeStartPoint(true)
    setIsModalOpen(false)
  }, [setResumeStartPoint])

  const handleContinue = useCallback(() => {
    setShowDemographicConfirmation(true)
    setIsModalOpen(false)
  }, [])

  const handleDemographicContinue = useCallback(() => {
    setResumeStartPoint(false)
    setShowDemographicConfirmation(false)
  }, [setResumeStartPoint])

  const handleDemographicGoBack = useCallback(() => {
    setShowDemographicConfirmation(false)
    setIsModalOpen(true)
  }, [])

  const preparedActionButtons = React.useMemo(() => {
    const actions = []

    actions.push(
      <Button
        key="restart"
        variant="primary"
        onClick={handleRestartFromBeginning}
      >
        Start Over From Beginning
      </Button>,
      <Button key="continue" variant="primary" onClick={handleContinue}>
        Resume Where You Left Off
      </Button>,
    )

    return actions
  }, [handleContinue, handleRestartFromBeginning])

  if (showDemographicConfirmation) {
    return (
      <FormScreen>
        <IntakeDemographics
          patient={patient}
          handleContinue={handleDemographicContinue}
          handleGoBack={handleDemographicGoBack}
          handleSubmit={handleSubmit}
        />
      </FormScreen>
    )
  }

  return (
    <FormScreen>
      <Modal
        variant={ModalVariant.small}
        isOpen={isModalOpen}
        actions={preparedActionButtons}
        showClose={false}
      >
        <h3>
          Please select whether you would like to start the survey over, or
          resume from your last answered question.
        </h3>
      </Modal>
    </FormScreen>
  )
}
